export default {
  login: {
    txt1: "游戏内神秘代码验证",
    txt2: "请输入神秘代码",
    txt3: "验证",
    txt4: "请选择服务器",
    txt5: "请选择角色信息",
    txt6: "登录",
    txt7: "帮助中心",
  },
  nav: {
    txt1: "首页",
    txt2: "赛事直播",
    txt3: "赛事进程",
    txt4: "赛事MVP",
    txt5: "观赛领奖励",
    txt6: "直播互动领周边",
    txt7: "赛事奖励",
    txt8: "赛事创作者计划",
  },
  live: {
    txt1: "赛程",
    txt2: "更多精彩直播间",
    txt3: "直播时间:",
    txt4: "直播内容:",
    txt5: "进入直播间",
    txt6: "直播时间",
    txt7: "对阵情况",
    txt8: "你好, 请登录",
  },
  process: {
    nav1: "积分赛排行榜",
    nav2: "淘汰赛-晋级图",
    nav3: "总积分排行榜",
    txt1: "排名",
    txt2: "战队名称",
    txt3: "服务器",
    txt4: "积分",
    txt5: "赛区",
    txt6: "击杀",
    list: ["赛区Ⅰ", "赛区Ⅱ", "赛区Ⅲ", "赛区Ⅳ"],
    img: require("@/assets/zh-img.jpg"),
  },
  periphery: {
    time1: "2023/11/22",
    title1: "福利一:半决赛-第一场比赛神秘礼包码",
    time2: "2023/11/24",
    title2: "福利二:半决赛-第二场比赛神秘礼包码",
    time3: "2023/11/25",
    title3: "福利三:冠军队伍福利礼包码",
    p1: "竞猜币",
    p2: "钻石",
    p3: "公会奖章箱",
    p4: "大型zeny宝箱",
    p5: "卡片抽奖券（珍稀）",
    p6: "高级精炼附魔礼盒",
  },
  mvp: {
    txt1: "历史最高数据",
    txt2: "角色服务器",
    txt3: "战队昵称",
    txt4: "角色昵称",
    txt5: "角色等级",
    txt6: "职业",
    txt7: "32强淘汰赛",
    txt8: "总决赛",
  },
  task: {
    loginTip: "亲爱的冒险者，请先登入以完成任务，领取奖励",
    reward830: "狄罗雕刻自选礼盒*10\n 观星幻境培养材料x50",
    task830: "8.30日累计观看<span>10分钟</span>",
    reward91: "狄罗之尘*300\n 观星幻境培养材料x50",
    task91: "9.1日累计观看<span>10分钟</span>",
    reward92: "珍贵印记随机礼盒*10 \n观星幻境培养材料x100",
    task92: "9.2日累计观看<span>10分钟</span>",
    reward94: "闪耀魔灵随机箱*3 \n观星幻境培养材料x100",
    task94: "9.4日累计观看<span>15分钟</span>",
    reward96: "闪耀魔灵随机箱*3 \n观星幻境培养材料x100",
    task96: "9.6日累计观看<span>15分钟</span>",
    reward98: "闪耀魔灵之钥*1 微光魔灵之钥*1 \n瑕疵的印记结晶*10",
    task98: "9.8日累计观看<span>15分钟</span>",
    rewardTotal2: "附魔硬币自选箱x2 \n附魔折扣券x100",
    taskTotal2: "完成2个观赛任务",
    rewardTotal5: "黃昏臂章x1 扭蛋抽奖券x5\n神兽召唤券x5",
    taskTotal5: "完成5个观赛任务",
    txt7: "当前进度",
    txt8: "未完成",
    txt9: "查 看",
    txt10: "领 取",
    txt11: "已领取",
  },
  reward: [
    {
      type: "淘汰赛",
      item: [
        {
          name: "冠军",
          image: require("@/assets/en-re1.png"),
          imageM: require("@/assets/mobile/en-re1.png"),
          list: [
            {
              name: "冠军坐骑",
              amount: "",
            },
            {
              name: "称号-2024索尔杯冠军战队",
              amount: "",
            },
            {
              name: "索尔杯冠军气泡框",
              amount: "",
            },
            {
              name: "索尔杯冠军头像框",
              amount: "",
            },
            {
              name: "勇者徽章",
              amount: "20",
            },
            {
              name: "喵果",
              amount: "20000",
            },
            {
              name: "钻石",
              amount: "5000",
            },
            {
              name: "橙色印记自选箱III",
              amount: "10",
            },
            {
              name: "雕像部位材料自选盒F",
              amount: "30",
            },
            {
              name: "光暗系列羽毛自选箱",
              amount: "40",
            },
            {
              name: "月之章",
              amount: "8",
            },
            {
              name: "神王雕像自选盒",
              amount: "10",
            },
          ],
        },
        {
          name: "亚军",
          image: require("@/assets/en-re2.png"),
          imageM: require("@/assets/mobile/en-re2.png"),
          list: [
            {
              name: "称号-2024索尔杯亚军战队",
              amount: "",
            },
            {
              name: "索尔杯亚军气泡框",
              amount: "",
            },
            {
              name: "索尔杯亚军头像框",
              amount: "",
            },
            {
              name: "勇者徽章",
              amount: "20",
            },
            {
              name: "喵果",
              amount: "10000",
            },
            {
              name: "钻石",
              amount: "4500",
            },
            {
              name: "橙色印记自选箱III",
              amount: "10",
            },
            {
              name: "雕像部位材料自选盒F",
              amount: "25",
            },
            {
              name: "光暗系列羽毛自选箱",
              amount: "36",
            },
            {
              name: "月之章",
              amount: "6",
            },
            {
              name: "神王雕像自选盒",
              amount: "8",
            },
          ],
        },
        {
          name: "4强",
          image: require("@/assets/en-re3.png"),
          imageM: require("@/assets/mobile/en-re3.png"),
          list: [
            {
              name: "称号-2024索尔杯4强战队",
              amount: "",
            },
            {
              name: "索尔杯4强气泡框",
              amount: "",
            },
            {
              name: "索尔杯4强头像框",
              amount: "",
            },
            {
              name: "勇者徽章",
              amount: "17",
            },
            {
              name: "喵果",
              amount: "5000",
            },
            {
              name: "钻石",
              amount: "4000",
            },
            {
              name: "橙色印记自选箱III",
              amount: "8",
            },
            {
              name: "雕像部位材料自选盒F",
              amount: "20",
            },
            {
              name: "光暗系列羽毛自选箱",
              amount: "32",
            },
            {
              name: "月之章",
              amount: "4",
            },
            {
              name: "神王雕像自选盒",
              amount: "6",
            },
          ],
        },
        {
          name: "8强",
          image: require("@/assets/en-re4.png"),
          imageM: require("@/assets/mobile/en-re4.png"),
          list: [
            {
              name: "称号-2024索尔杯8强战队",
              amount: "",
            },
            {
              name: "索尔杯8强气泡框",
              amount: "",
            },
            {
              name: "索尔杯8强头像框",
              amount: "",
            },
            {
              name: "勇者徽章",
              amount: "15",
            },
            {
              name: "喵果",
              amount: "3000",
            },
            {
              name: "钻石",
              amount: "3000",
            },
            {
              name: "橙色印记自选箱III",
              amount: "6",
            },
            {
              name: "雕像部位材料自选盒F",
              amount: "15",
            },
            {
              name: "光暗系列羽毛自选箱",
              amount: "28",
            },
            {
              name: "月之章",
              amount: "3",
            },
            {
              name: "神王雕像自选盒",
              amount: "4",
            },
          ],
        },
        {
          name: "16强",
          image: require("@/assets/en-re5.png"),
          imageM: require("@/assets/mobile/en-re5.png"),
          list: [
            {
              name: "称号-2024索尔杯16强战队",
              amount: "",
            },
            {
              name: "索尔杯16强气泡框",
              amount: "",
            },
            {
              name: "索尔杯16强头像框",
              amount: "",
            },
            {
              name: "勇者徽章",
              amount: "7",
            },
            {
              name: "喵果",
              amount: "2000",
            },
            {
              name: "钻石",
              amount: "2000",
            },
            {
              name: "橙色印记自选箱III",
              amount: "4",
            },
            {
              name: "雕像部位材料自选盒F",
              amount: "10",
            },
            {
              name: "光暗系列羽毛自选箱",
              amount: "24",
            },
            {
              name: "月之章",
              amount: "2",
            },
            {
              name: "神王雕像自选盒",
              amount: "2",
            },
          ],
        },
        {
          name: "32强",
          image: require("@/assets/en-re6.png"),
          imageM: require("@/assets/mobile/en-re6.png"),
          list: [
            {
              name: "称号-2024索尔杯32强战队",
              amount: "",
            },
            {
              name: "索尔杯32强气泡框",
              amount: "",
            },
            {
              name: "索尔杯32强头像框",
              amount: "",
            },
            {
              name: "勇者徽章",
              amount: "5",
            },
            {
              name: "喵果",
              amount: "1500",
            },
            {
              name: "橙色印记自选箱III",
              amount: "2",
            },
            {
              name: "雕像部位材料自选盒F",
              amount: "5",
            },
            {
              name: "光暗系列羽毛自选箱",
              amount: "20",
            },
            {
              name: "月之章",
              amount: "1",
            },
            {
              name: "钻石",
              amount: "1500",
            },
          ],
        },
      ],
    },
    {
      type: "积分赛",
      item: [
        {
          name: "晋级1-4",
          image: require("@/assets/en-re7.png"),
          imageM: require("@/assets/mobile/en-re7.png"),
          list: [
            {
              name: "索尔杯精英气泡",
              amount: "",
            },
            {
              name: "称号-2024索尔杯精英战队",
              amount: "",
            },
            {
              name: "索尔杯精英气泡框",
              amount: "",
            },
            {
              name: "索尔杯精英头像框",
              amount: "",
            },
            {
              name: "勇者徽章",
              amount: "40",
            },
            {
              name: "喵果",
              amount: "2500",
            },
            {
              name: "橙色印记自选箱III",
              amount: "3",
            },
            {
              name: "光暗系列羽毛自选箱",
              amount: "30",
            },
            {
              name: "时空系列羽毛自选箱",
              amount: "50",
            },
            {
              name: "雕像部位材料自选盒F",
              amount: "15",
            },

            {
              name: "钻石",
              amount: "2500",
            },
          ],
        },
        {
          name: "晋级5-8",
          image: require("@/assets/en-re8.png"),
          imageM: require("@/assets/mobile/en-re8.png"),
          list: [
            {
              name: "索尔杯精英气泡",
              amount: "",
            },
            {
              name: "称号-2024索尔杯精英战队",
              amount: "",
            },
            {
              name: "索尔杯精英气泡框",
              amount: "",
            },
            {
              name: "索尔杯精英头像框",
              amount: "",
            },
            {
              name: "勇者徽章",
              amount: "35",
            },
            {
              name: "喵果",
              amount: "2300",
            },
            {
              name: "橙色印记自选箱III",
              amount: "3",
            },
            {
              name: "光暗系列羽毛自选箱",
              amount: "25",
            },
            {
              name: "时空系列羽毛自选箱",
              amount: "45",
            },
            {
              name: "雕像部位材料自选盒F",
              amount: "13",
            },

            {
              name: "钻石",
              amount: "2300",
            },
          ],
        },
        {
          name: "晋级9-16",
          image: require("@/assets/en-re9.png"),
          imageM: require("@/assets/mobile/en-re9.png"),
          list: [
            {
              name: "索尔杯精英气泡",
              amount: "",
            },
            {
              name: "称号-2024索尔杯精英战队",
              amount: "",
            },
            {
              name: "索尔杯精英气泡框",
              amount: "",
            },
            {
              name: "索尔杯精英头像框",
              amount: "",
            },
            {
              name: "勇者徽章",
              amount: "33",
            },
            {
              name: "喵果",
              amount: "2000",
            },
            {
              name: "橙色印记自选箱III",
              amount: "3",
            },
            {
              name: "光暗系列羽毛自选箱",
              amount: "20",
            },
            {
              name: "时空系列羽毛自选箱",
              amount: "40",
            },
            {
              name: "雕像部位材料自选盒F",
              amount: "12",
            },

            {
              name: "钻石",
              amount: "2000",
            },
          ],
        },
        {
          name: "晋级17-32",
          image: require("@/assets/en-re10.png"),
          imageM: require("@/assets/mobile/en-re10.png"),
          list: [
            {
              name: "索尔杯精英气泡",
              amount: "",
            },
            {
              name: "称号-2024索尔杯精英战队",
              amount: "",
            },
            {
              name: "索尔杯精英气泡框",
              amount: "",
            },
            {
              name: "索尔杯精英头像框",
              amount: "",
            },
            {
              name: "勇者徽章",
              amount: "30",
            },
            {
              name: "喵果",
              amount: "1900",
            },
            {
              name: "橙色印记自选箱III",
              amount: "3",
            },
            {
              name: "光暗系列羽毛自选箱",
              amount: "19",
            },
            {
              name: "时空系列羽毛自选箱",
              amount: "38",
            },
            {
              name: "雕像部位材料自选盒F",
              amount: "11",
            },

            {
              name: "钻石",
              amount: "1900",
            },
          ],
        },
        {
          name: "未晋级",
          image: require("@/assets/en-re11.png"),
          imageM: require("@/assets/mobile/en-re11.png"),
          list: [
            {
              name: "索尔杯精英气泡",
              amount: "",
            },
            {
              name: "称号-2024索尔杯精英战队",
              amount: "",
            },
            {
              name: "索尔杯精英气泡框",
              amount: "",
            },
            {
              name: "索尔杯精英头像框",
              amount: "",
            },
            {
              name: "勇者徽章",
              amount: "28",
            },
            {
              name: "喵果",
              amount: "1800",
            },
            {
              name: "橙色印记自选箱III",
              amount: "2",
            },
            {
              name: "光暗系列羽毛自选箱",
              amount: "18",
            },
            {
              name: "时空系列羽毛自选箱",
              amount: "36",
            },
            {
              name: "雕像部位材料自选盒F",
              amount: "10",
            },

            {
              name: "钻石",
              amount: "1800",
            },
          ],
        },
        {
          name: "参与奖",
          image: require("@/assets/en-re12.png"),
          imageM: require("@/assets/mobile/en-re12.png"),
          list: [
            {
              name: "钻石",
              amount: "100",
            },
            {
              name: "强者印记",
              amount: "200",
            },
            {
              name: "稀有印记随机礼盒",
              amount: "1",
            },
            {
              name: "时空系列羽毛自选箱",
              amount: "5",
            },
            {
              name: "超级饼干",
              amount: "5",
            },
            {
              name: "紫色羽毛自选箱",
              amount: "10",
            },
          ],
        },
      ],
    },
  ],
  dia: {
    txt1: "礼包码",
    txt2: "复制",
    txt3: "复制成功",
  },
};
